export function setCacheaccessLoading (state, loading = false) {
  state.cacheaccessLoading = loading
}

export function setCacheaccess (state, cacheaccess) {
  if (cacheaccess && cacheaccess.data) {
    state.cacheaccess = cacheaccess.data
    state.cacheaccessCurrentPage = cacheaccess.current_page
    state.cacheaccessLastPage = cacheaccess.last_page
    state.cacheaccessPerPage = cacheaccess.per_page
    state.cacheaccessTotal = cacheaccess.total
  } else if (cacheaccess && Array.isArray(cacheaccess)) {
    state.cacheaccess = cacheaccess
    state.cacheaccessCurrentPage = 1
    state.cacheaccessLastPage = 1
    state.cacheaccessPerPage = 100
    state.cacheaccessTotal = cacheaccess.length
  }
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
